import { Injectable, EventEmitter } from "@angular/core";
import { ApiService } from "./api.service";
import { ApiResponse } from "../interfaces";
import { Observable, of } from "rxjs";
import { Order, Picker, CommonsSetting } from "../models";
import { environment } from "../../../environments/environment";
import { Constants } from "../../core/configs";
import { TempStorageService } from "./temp-storage.service";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PickService extends TempStorageService {
  passedEvents = new EventEmitter<any>();
  /**
   * Creates an instance of pick service.
   * @param apiService: ApiService
   */
  constructor(public apiService: ApiService) {
    super();
  }
  /**
   * Gets states order
   * @returns Observable
   */
  getStatesOrder(): Observable<ApiResponse> {
    const statesStorage = this.getStorage("STATE_ORDER");
    return statesStorage
      ? of(statesStorage)
      : this.apiService
        .get(`${this.apiService.getStatusOrderPicking}`)
        .pipe(tap((res) => this.setStorage("STATE_ORDER", res)));
  }

  getOrdersShift(): Observable<any> {
    // this.apiService.get(`${this.apiService.getShiftOrderPicking}`)
    const shiftsStorage = this.getStorage("ORDER_SHIFT");
    return shiftsStorage
      ? of(shiftsStorage)
      : this.apiService
        .get(`${this.apiService.getShiftOrderPicking}`)
        .pipe(tap((res) => this.setStorage("ORDER_SHIFT", res)));
  }

  /**
   * Gets orders
   * @param params any
   * @returns orders  Observable<Order[]>
   */
  getOrders(params: any): Observable<Order[]> {
    return this.apiService.get(this.apiService.getOrdersPickingReport, params);
  }

  /**
   * Gets audit report
   * @param params any
   * @returns orders  Observable<Order[]>
   */
   getAuditReport(params: any): Observable<Order[]> {
    return this.apiService.get(this.apiService.getAuditReport, params);
  }

  getPickers(entityId: string, isExternalUser: boolean): Observable<Picker[]> {
    let api: string = this.apiService.getPickers + "?";
    if (entityId != null) {
      api += `entityId=${entityId}&`;
    }
    if (entityId != null) {
      api += `isExternalUser=${isExternalUser}&`;
    }
    return this.apiService.get(api);
  }
  /**
   * Gets pickers assined
   * @returns Observable<any[]>
   */
  getPickersAssined(): Observable<any[]> {
    return this.apiService.get(
      `${environment.apiPicking}/pickers/assigmed-orders`
    );
  }
  /**
   * Posts orders deallocate
   * @param params any
   * @returns Observable<any[]>
   */
  postOrdersDeallocate(params: any) {
    return this.apiService.post(
      `${environment.apiPicking}/orders/deallocate`,
      params
    );
  }

  updateAssignPicker(idPicker: string, body: string[]) {
    return this.apiService.put(
      `${this.apiService.businessPicking}/orders/assign/${idPicker}/PENDIENTE_PICKING`,
      body
    );
  }

  unassignOrders(body: number[]) {
    return this.apiService.put(
      `${this.apiService.businessPicking}/orders/unassign`,
      body
    );
  }

  getConsolidationDispatch(filter: any) {
    return this.apiService.get(
      `${this.apiService.getOrdersPickingReport}/consolidation/dispatch`,
      filter
    );
  }

  getEmbedToken() {
    return this.apiService.get(
      `${this.apiService.getOrdersPickingReport}/embeddings`
    );
  }

  getConsolidationDispatchPaginated(filter: any) {
    return this.apiService.get(
      `${this.apiService.getOrdersPickingReport}/consolidation/dispatch/paginated`,
      filter
    );
  }

  getLabelled(idOrderDispatch: number) {
    return this.apiService.get(
      `${environment.apiBusinessPickingRead}/api/business-irdgco-picking-read/v1/labelled/${idOrderDispatch}`
    );
  }

  postLabelledByIdsOrderDispatch(params: any) {
    return this.apiService.post(`${environment.apiPicking}/labelled`, params);
  }

  geOrdersLeaveOrder(params?: any) {
    return this.apiService.get(
      `${environment.apiPicking}/orders/leaveOrder`,
      params
    );
  }
  /**
   * Gets report orders xls
   * @param params
   * @returns ReportOrdersTotal[]
   */
  getReportOrdersXls(params: any): Observable<any> {
    return this.apiService.get(`${environment.apiPicking}/orders/xls`, params);
  }
  /**
   * Gets orders report
   * @param params any
   * @returns  Observable<any>
   */
  getOrdersReport(params: any): Observable<any> {
    return this.apiService.post(`${environment.apiRunPickingReport}/orders/pickingReport`, params);
  }

  getOrdersReportToPromise(params: any): Promise<any> {
    return this.apiService.post(`${environment.apiRunPickingReport}/orders/pickingReport`, params).toPromise();
  }

  getOrdersPickingReportToPromise(params: any): Promise<any> {
    return this.apiService.post(`${environment.apiRunPickingReport}/orders/pickingReportFromDashboard`, params).toPromise();
  }

  /**
   * Gets report orders pending xls
   * @param params
   * @returns ReportOrdersTotal[]
   */
  getReportOrdersPendingXls(params: any) {
    return this.apiService.get(
      `${environment.apiPicking}/orders/xls/pending`,
      params
    );
  }

  getLabelledDetail(idOrderDispatch: number) {
    return this.apiService.get(
      `${environment.apiRunPickingReport}/labelled/detail/${idOrderDispatch}`
    );
  }

  getLabelledDetails(idOrderDispatch: string) {
    return this.apiService.get(`${environment.apiRunPickingReport}/labelled/details/${idOrderDispatch}`);
  }
  getLabelledDetailPromise(idOrderDispatch: string) {
    return new Promise((resolve, reject) => {
      this.apiService.get(`${environment.apiRunPickingReport}/labelled/details/${idOrderDispatch}`).subscribe(data => resolve(data));
    });
  }

  getStateOrderDispatch() {
    const statesStorage = this.getStorage("STATE_ORDER_DISPATCH");
    return statesStorage
      ? of(statesStorage)
      : this.apiService
        .get(`${environment.apiPicking}/orderDispatch/states`)
        .pipe(tap((res) => this.setStorage("STATE_ORDER_DISPATCH", res)));
  }

  postNotificationDispatch(params: any) {
    return this.apiService.post(
      `${environment.apiPicking}/notification/dispatch`,
      params
    );
  }

  updatePendingPrint(params: any) {
    return this.apiService.put(
      `${environment.apiPicking}/dispatch/print`,
      params
    );
  }

  postOrdersPrecancelByIdsOrderPicking(params: any) {
    return this.apiService.post(
      `${this.apiService.businessPicking}/orderDispatch/precancel/orderPicking`,
      params
    );
  }

  postOrderDispatchPrecancelByIdsOrderDispatch(params: any) {
    return this.apiService.post(
      `${this.apiService.businessPicking}/orderDispatch/precancel`,
      params
    );
  }

  putCommonsSetting(params: CommonsSetting) {
    return this.apiService.put(
      `${environment.apiPicking}/commons/setting`,
      params
    );
  }

  getCommonsSetting() {
    return this.apiService.get(`${environment.apiPicking}/commons/setting`);
  }
  /**
   * Gets name document
   * @param DOCUMENT_TYPE
   * @returns Observable<any>
   */
  getNameDocument(DOCUMENT_TYPE: string) {
    const document = Constants.Customer.DOCUMENT_TYPES.getProps(DOCUMENT_TYPE);
    return document ? document.text : "-";
  }
  /**
   * Gets paymentmethod
   * @returns Observable<any>
   */
  getPaymentmethod() {
    const paymentMethodStorage = this.getStorage("PAYMENT_METHOD");
    return paymentMethodStorage
      ? of(paymentMethodStorage)
      : this.apiService
        .get(`${environment.apiPicking}/paymentmethod`)
        .pipe(tap((res) => this.setStorage("PAYMENT_METHOD", res)));
  }
  /**
   * Gets methoddelivery
   * @returns Observable<any>
   */
  getMethoddelivery() {
    const methoddelivery = this.getStorage("METHOD_DELIVERY");
    return methoddelivery
      ? of(methoddelivery)
      : this.apiService
        .get(`${environment.apiPicking}/methoddelivery`)
        .pipe(tap((res) => this.setStorage("METHOD_DELIVERY", res)));
  }

  containerReallocation(body: any):Observable<any> {
    return this.apiService.put(
      `${this.apiService.containerReallocation}`,
      body
    ).pipe();
  }

  getRequiredSkusReport(params: any) {
    return this.apiService.post(`${environment.apiBusinessPickingRead}/api/business-irdgco-picking-read/v1/report/required/skus`, params);
  } 

  closeSessionMassive(closeSessionRequest: any): Observable<any> {
    return this.apiService.put(`${this.apiService.businessPicking}/picker/session/close-session-massive`, closeSessionRequest);
  }

}
